module.exports = __webpack_public_path__ + "img/person-running.ad7e3374.png";